"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2 1v14c0 .55.45 1 1 1h1V0H3c-.55 0-1 .45-1 1zm11-1h-1v7l-2-2-2 2V0H5v16h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"];
//# sourceMappingURL=book.js.map